import * as React from 'react'
import { Elements} from '@tfo/common'
import { inject, observer } from 'mobx-react'
import { FormattedMessage, injectIntl, useIntl, WrappedComponentProps } from 'react-intl'
import { RouteComponentProps, withRouter } from 'react-router'
import Loader from '../../components/common/loader/Loader'
import RootStore from '../../stores/RootStore'
import VerificationCodeLogin from './VerificationCodeLogin'
import LanguageSelector from '../../components/header/LanguageSelector'
import './LoginIndividual.scss'
import LoginHelpModal from '../../components/modals/login-help-modal/LoginHelpModal'
import TechnicalIssuesMessage from '../../components/technical-issues-message/TechnicalIssuesMessage'

export interface ILoginIndividual {
	rootStore?: RootStore
}

const { Heading3 } = Elements

const LoginIndividual = (
	props: ILoginIndividual & WrappedComponentProps & RouteComponentProps,
) => {
	const intl = useIntl()
	const store = props.rootStore!.loginStore!
	const userStore = props.rootStore.userStore
	const [showHelpModal, setShowHelpModal] = React.useState(false)

	return <>
		<div className="LoginIndividual">
			<div className="LoginIndividualHeader">
				<Heading3 style={{ color: '#009B48' }}>
					<FormattedMessage id="common.login" />
				</Heading3>
				<LanguageSelector
					language={userStore.languageSettings.language}
					onSelectLanguageCode={l => userStore.setLanguage(l)}
					displayAs="Switch" />
			</div>
			<TechnicalIssuesMessage />
			<VerificationCodeLogin
				onProgress={loading => store.loading = loading}
			/>
			<div className="LoginInfo">
				<p
					onClick={() => setShowHelpModal(true)}
					style={{cursor: 'pointer', textDecoration: 'underline'}}
				>
					<FormattedMessage id="login.help.title"/>
				</p>
				<p className='LoginInfo-paragraph'>
					<FormattedMessage id="login.information.contact" />
					<a
						className='info-mail-link'
						href={'mailto:info@tofindout.se'}
						target='_self'>
						{intl.formatMessage({ id: 'login.information.mail' })}
					</a>
				</p>
			</div>

			{store.loading && (
				<Loader/>
			)}

		</div>
		<LoginHelpModal
			showHelpModal={showHelpModal}
			onCloseClick={() => setShowHelpModal(false)}
		/>
	</>
}

export default withRouter(
	inject('rootStore')(injectIntl(observer(LoginIndividual))),
)
